
import {
  GENERATE_KEYWORDS_START,
  GENERATE_KEYWORDS_SUCCESS,
  GENERATE_KEYWORDS_FAILED,
  GENERATE_HEADINGS_START,
  GENERATE_HEADINGS_SUCCESS,
  GENERATE_HEADINGS_FAILED,
  SAVE_SELECTED_HEADING,
  GENERATE_DESCRIPTION_START,
  GENERATE_DESCRIPTION_SUCCESS,
  GENERATE_DESCRIPTION_FAILED,
  CLEAR_AI_REDUCER
} from "../store/types";

const INITIAL_STATE = {
  aiGeneratedDescription: "",
  aiGeneratedTitle: "",

  loadingDescription: false,
  errorDescription: {
    error: false,
    message: null
  },
  aiGeneratedKeywords: "",


  loadingKeywords: false,
  errorKeywords: {
    error: false,
    message: null
  },

  completed: false,
  loadingKeywords: false,
  loadingHeadings: false,
  error: null,
};

export const AIreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    /* -------------------- KEYWORDS -------------------- */
    case GENERATE_KEYWORDS_START:
      return {
        ...state,
        loadingKeywords: true,
        error: null,
      };

    case GENERATE_KEYWORDS_SUCCESS: {
      const { keywords } = action.payload;
      return {
        ...state,
        completed: true,
        loadingKeywords: false,
        aiGeneratedKeywords: keywords
      };
    }

    case GENERATE_KEYWORDS_FAILED:
      return {
        ...state,
        loadingKeywords: false,
        completed: true,
        errorKeywords: {
          error: true,
          message: action.payload.error
        },
      };



    case CLEAR_AI_REDUCER:
      return {
        ...INITIAL_STATE
      };



    /* -------------------- HEADINGS -------------------- */
    case GENERATE_HEADINGS_START:
      return {
        ...state,
        loadingHeadings: true,
        error: null,
      };

    case GENERATE_HEADINGS_SUCCESS: {
      const { listingId, headings } = action.payload;
      return {
        ...state,
        loadingHeadings: false,
        listings: {
          ...state.listings,
          [listingId]: {
            ...(state.listings[listingId] || {}),
            headings,
          },
        },
      };
    }

    case GENERATE_HEADINGS_FAILED:
      return {
        ...state,
        loadingHeadings: false,
        error: action.payload,
      };

    /* -------------------- SAVE SELECTED HEADING -------------------- */
    case SAVE_SELECTED_HEADING: {
      const { listingId, heading } = action.payload;
      return {
        ...state,
        listings: {
          ...state.listings,
          [listingId]: {
            ...(state.listings[listingId] || {}),
            selectedHeading: heading,
          },
        },
      };
    }
    case GENERATE_DESCRIPTION_START: {
      return {
        ...state,
        loadingDescription: true,
        completed: false
      };
    }

    case GENERATE_DESCRIPTION_SUCCESS: {

      return {
        ...state,
        aiGeneratedDescription: action.payload.description,
        aiGeneratedTitle: action.payload.title,
        loadingDescription: false,
        completed: true
      };
    }

    case GENERATE_DESCRIPTION_FAILED: {
      return {
        ...state,
        loadingDescription: false,
        errorDescription: {
          error: true,
          message: action.payload.error
        }
      };
    }

    default:
      return state;
  }
}
